import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export interface PagerProps {
  page: number;
  totalPages: number;
  total: number;
  onPageChange: (page: number) => void;
}

export const PagerComponent: React.FC<PagerProps> = ({
  page,
  totalPages,
  total,
  onPageChange,
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      gap={1}
      mt={1.5}
    >
      <Typography fontSize="0.75rem" color="gray">
        {total} résultat{total > 1 ? "s" : ""}
      </Typography>
      <Box display="flex" alignItems="center" gap={0.5}>
        <IconButton
          size="small"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          sx={{ color: "#B4006E" }}
        >
          <ChevronLeftIcon fontSize="small" />
        </IconButton>
        <Typography
          fontSize="0.8rem"
          fontWeight="600"
          sx={{ minWidth: "72px", textAlign: "center" }}
        >
          Page {page} / {Math.max(totalPages, 1)}
        </Typography>
        <IconButton
          size="small"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          sx={{ color: "#B4006E" }}
        >
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};
